import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Card,
  PageActions,
  Avatar,
  Toast,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import countriesData from "../Data/countries.json";
import { MultiSelect } from "react-multi-select-component";

const CountriesSettings = () => {
  const [countries, setCountries] = useState([]);
  const [optionsCountries, setOptionsCountries] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const handleChange = (e) => {
    setCountries(e);
  };
  useEffect(() => {
    setOptionsCountries(
      countriesData.map((item) => ({
        label: `${item.name}`,
        value: item.name,
        flag: item.image,
      }))
    );
  }, []);
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        console.log("test=", res.data.data);

        res.data.data?.length &&
          setCountries(
            res.data.data.map((item) => ({
              label: item.name,
              value: item.name,
            }))
          );
      })
      .catch((err) => console.error(err));
  }, [optionsCountries]);

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((a) => !a), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  return (
    <Page title="Countries">
      <MultiSelect
        options={optionsCountries}
        onChange={(e) => handleChange(e)}
        value={countries}
        placeholder="Please select"
      />
      <PageActions
        primaryAction={{
          content: "Save",
          onAction: handleSave,
          loading: isSaving,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    setIsSaving(true);
    const formData = new FormData();
    countries.length &&
      countries.forEach((selected, index) => {
        formData.append(`countries[${index}][name]`, selected.value);
        formData.append(`countries[${index}][flag]`, selected.flag);
      });
    formData.append(`_method`, "PATCH");
    axios
      .post(`/settings/countries`, formData)
      .then(() => {
        toggleActive();
      })
      .catch((error) => {
        console.log(error.response);
        setIsSaving(false);
      })
      .finally(() => setIsSaving(false));
  }
};

export default CountriesSettings;
